<div class="container">
    <p class="error-message">An error has occurred during the application process.</p>
    <p class="support-link"><a href="#">Contact customer support : {{ supportPhoneNumber }}</a></p>
  </div>